module.exports = __webpack_public_path__ + "img/seleccione-planta-unidad.0b02ba19.png";